<template>
   <div
      data-cy="is-representing-banner"
      class="text-bolder fixed inset-x-0 top-0 w-full bg-warning text-center text-black"
      style="z-index: 10000"
   >
      <p aria-live="polite" class="truncate px-6 py-2 lg:px-8">
         {{
            userNameOrEmail
               ? $t("system.impersonation.with_name", { name_or_email: userNameOrEmail })
               : $t("system.impersonation.without_name")
         }}
      </p>
   </div>
</template>

<script setup lang="ts">
import { useI18n } from "@/vue-i18n/vue-i18n";

const { t: $t } = useI18n();

interface Props {
   userNameOrEmail: string; // this will either be an email or a name
}

defineProps<Props>();
</script>
